// Vote maths. Deliberately tiny and pure — the server is the only caller that matters, but the
// client uses the same functions so the number on screen and the number on the server agree.
/** Living players, which the threshold is measured against. Living Travelers count. */
export function livingCount(seats) {
    return seats.filter((s) => s.alive).length;
}
/** A nominee needs votes ≥ half the living players, rounded up. Ghost votes are counted in the tally, not here. */
export function voteThreshold(seats) {
    return Math.ceil(livingCount(seats) / 2);
}
/** An exile needs votes ≥ half of every player, living or dead. */
export function exileThreshold(seats) {
    return Math.ceil(seats.length / 2);
}
/**
 * When a seat's window closes, in ms after the clock starts. The hand starts at the nominee and
 * sweeps once around the circle, so the nominee votes last.
 */
export function seatVoteDeadlineMs(seatCount, nomineeIndex, seatIndex, msPerSeat) {
    const offset = (seatIndex - nomineeIndex + seatCount) % seatCount;
    // offset 0 is the nominee: last to lock, one full sweep in.
    const position = offset === 0 ? seatCount : offset;
    return position * msPerSeat;
}
/** Whether a seat's vote is already locked in, given how long the clock has been running. */
export function isSeatVoteLocked(seatCount, nomineeIndex, seatIndex, msPerSeat, elapsedMs) {
    return elapsedMs >= seatVoteDeadlineMs(seatCount, nomineeIndex, seatIndex, msPerSeat);
}
/** Total sweep duration for one nomination. */
export function totalSweepMs(seatCount, msPerSeat) {
    return seatCount * msPerSeat;
}
/**
 * Of the day's nominations, which one (if any) may be executed: the single highest tally that
 * also clears the threshold. A tie at the top means nobody is executed that day.
 */
export function leadingNomination(nominations, threshold) {
    const clearing = nominations.filter((n) => n.tally >= threshold);
    if (clearing.length === 0)
        return { leader: null, tied: false };
    const best = Math.max(...clearing.map((n) => n.tally));
    const top = clearing.filter((n) => n.tally === best);
    if (top.length > 1)
        return { leader: null, tied: true };
    return { leader: top[0], tied: false };
}
//# sourceMappingURL=voting.js.map